import { isGlobal } from 'conf'
import PLAN_TYPE from 'types/utils'

const UPGRADE_ELIGIBLE_ROLES = ['owner', 'admin']

export function canShowUpgradeButton({ paidLicense, workspace } = {}) {
  return (
    isGlobal() &&
    paidLicense?.plan_type === PLAN_TYPE.TRIAL &&
    UPGRADE_ELIGIBLE_ROLES.includes(workspace?.role?.toLowerCase())
  )
}

export default canShowUpgradeButton
